import Enhancer from '../enhancer.js';
import EnhancerApp from '../enhancer-app.js';
const ics = require('ics');

export default class IcsFile extends Enhancer {
    event = {
        title: '',
        description: '',
        location: '',
        start: [],
        end: [],
    };

    init() {
        // Dates need to be formatted as: [2021, 4, 8 ... ]
        const startDate = this.element.dataset.startDate.split('-');
        const startDateArr = Array.from(startDate, (date) => parseInt(date));
        const endDate = this.element.dataset.endDate.split('-');
        const endDateArr = Array.from(endDate, (date) => parseInt(date));

        this.event.title = this.element.dataset.title;
        this.event.description = this.element.dataset.description;
        this.event.location = this.element.dataset.location;
        this.event.start = startDateArr;
        this.event.end = endDateArr;

        const icsFile = this.createIcsFile();
        const file = new Blob([icsFile], {
            type: 'text/calendar;charset=utf-8',
        });
        const url = URL.createObjectURL(file);

        this.element.href = url;
        this.element.download = this.event.title;
    }

    createIcsFile() {
        let response = '';

        // See documentation for npm package at: https://www.npmjs.com/package/ics
        ics.createEvent(this.event, (error, value) => {
            if (error) {
                console.log(error);
                return;
            }

            response = value;
        });

        return response;
    }
}

// Enhancers must be registered with a name that is used in the data-enhancer attribute
EnhancerApp.register('IcsFile', IcsFile);
